/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Hide_Config_PanelInputs */

const cs_workflow_hide_config_panel = /** @type {(inputs: Workflow_Hide_Config_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt panel konfigurace`)
};

const en_workflow_hide_config_panel = /** @type {(inputs: Workflow_Hide_Config_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide configuration panel`)
};

/**
* | output |
* | --- |
* | "Hide configuration panel" |
*
* @param {Workflow_Hide_Config_PanelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_hide_config_panel = /** @type {((inputs?: Workflow_Hide_Config_PanelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Hide_Config_PanelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_hide_config_panel(inputs)
	return cs_workflow_hide_config_panel(inputs)
});